<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <h2 mat-dialog-title>Edit Campaign Json</h2>
  <div mat-dialog-content class="content">
    <mat-form-field>
      <mat-label>Json</mat-label>
      <textarea required matInput placeholder="" formControlName="json" rows="20" cols="80"></textarea>
      @if (!form.get('json').valid) {
        <mat-error>Please enter a valid json</mat-error>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions class="gap-8">
    <lib-button variant="stroked" (buttonClick)="onClose()">Cancel</lib-button>
    <lib-button type="submit" variant="raised" color="primary" [disabled]="!form.valid">Save</lib-button>
  </div>
</form>
